import { reactive } from 'vue'

export function useForm<T extends Record<string, unknown>>(initialFields: T) {
  const fields = reactive({ ...initialFields }) as T
  const errors = reactive<Record<string, string[]>>({})

  function setErrors(newErrors: Record<string, string[]>): void {
    Object.keys(errors).forEach((key) => {
      delete errors[key]
    })
    Object.assign(errors, newErrors)
  }

  function resetErrors(): void {
    Object.keys(errors).forEach((key) => {
      delete errors[key]
    })
  }

  function isValid(): boolean {
    return Object.keys(errors).length === 0
  }

  return { fields, errors, setErrors, resetErrors, isValid }
}
